<template>
  <main class="loan-order-list">
    <section class="order-content-wrapper">
      <div
        v-if="loanList.length"
        class="loan-order"
        v-for="(item, index) in loanList"
        :key="index"
      >
        <header class="list-head">
          <span>借款单号{{ item.loanOrderId }}</span>
          <span>申请日期:{{ item.loanOrderTime }}</span>
          <el-tooltip class="item" effect="dark" placement="right">
            <div slot="content">{{ item.tenantName }}</div>
            <span class="tenantName">申请人:{{ item.tenantName }}</span>
          </el-tooltip>
        </header>
        <div class="list-info">
          <p class="repay-common">
            <span>借款总额(元)</span>
            <span class="moneny"
              >{{ $utils.fenToWan(item.loanAmount) }}
              <span class="wan">万</span></span
            >
          </p>
          <b
            class="agree-btn"
            v-if="item.loanStatus == 30"
            @click="signContract(item.loanOrderId)"
            >签署合同</b
          >
          <b class="agree-btn signing" v-if="item.loanStatus == 35">签署中</b>
          <span
            class="loan-status"
            v-if="item.loanStatus !== 30 && item.loanStatus !== 35"
            >{{ item.loanStatusName }}</span
          >
          <p>
            <span
              class="repay-detail"
              @click.stop="checkDetail(item.loanOrderId)"
              >查看详情</span
            >
            <span
              class="repay-detail"
              v-if="item.loanStatus == 10"
              @click.stop="cancel(item.loanOrderId)"
              >取消用款</span
            >
          </p>
        </div>
      </div>
      <div class="no-data" v-if="!loanList.length">
        <p class="img-wrapper">
          <img src="../../../assets/images/orange-loan/no-bill.png" alt="" />
          <span class="nobill-info">您暂无借款</span>
        </p>
      </div>
    </section>
  </main>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      tableData: [],
    }
  },
  computed: {
    ...mapState('loan', ['loanList', 'cancelData']),
  },
  created() {
    this.$emit('to-loan-launch', {
      status: 0,
    })
    this.getRepayList()
  },
  methods: {
    checkDetail(loanOrderId) {
      this.$router.push({
        name: 'orangeLoanApplyStatus',
        query: { loanOrderId: loanOrderId },
      })
    },
    cancel(loanOrderId) {
      this.$confirm('', '', {
        message: `<p class="title">您确定要取消用款申请吗?</p><p class="text">该操作不可撤回,请谨慎操作</p>`,
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: true,
        showClose: false,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
      })
        .then(() => {
          // 跳转页面
          this.$request({
            url: '/proxy/oneCar/api/loan/cancel',
            data: {
              loanOrderId,
            },
            method: 'post',
          }).then((res) => {
            if (!res.errorCode) {
              this.$message({
                message: '取消用款成功!',
                type: 'success',
              })
              this.getRepayList()
              this.$store.dispatch('loan/GET_CUSTOMER_INFO')
            } else {
              this.$message.error(res.errorMsg)
            }
          })
        })
        .catch(() => {})
    },
    getRepayList() {
      this.$store.dispatch('loan/GET_LOAN_LIST', {
        pageSize: 10000,
        loanType: '0,10,20,30,35,40',
      })
    },
    signContract(loanOrderId) {
      this.$request({
        url: '/proxy/oneCar/api/loan/contract/sign/apply',
        method: 'post',
        data: {
          loanOrderId,
        },
      }).then((res) => {
        if (!res.errorCode) {
          this.$message({
            message: '签署合同申请已发送!',
            type: 'success',
          })
          this.getRepayList()
        } else {
          this.$message.error(res.errorMsg)
        }
      })
    },
  },
}
</script>
<style lang="stylus">
@import '../../../assets/css/common-color.styl'
.loan-order-list
  .order-content-wrapper
    .no-data
      margin-top 60px
      .img-wrapper
        display flex
        align-items center
        justify-content center
        flex-direction column
        img
          width 160px
          height 160px
        .nobill-info
          font-size 14px
          color gray03
    .loan-order
      border 1px solid #dcdfe6
      .list-head
        height 48px
        line-height 44px
        background #F4F5F7
        padding 0 24px
        display flex
        justify-content center
        align-items center
        .tenantName
          text-overflow ellipsis
          flex 1
          overflow hidden
        span
          margin-right 40px
          font-family PingFangSC-Regular
          font-size 12px
          color gray02
          line-height 14px
          flex 2
          white-space nowrap
      .list-info
        padding 28px 108px
        box-sizing  border-box
        display flex
        justify-content space-between
        align-items center
        .repay-common
          font-size 12px
          color gray02
          display flex
          flex-direction column
          justify-content space-around
          align-items center
          .moneny
            font-size 24px
            font-family DINPro
            color gray01
            .wan
              font-size 16px
              position relative
              top -2px
              left -4px
              font-family PingFangSC-Medium
        .agree-btn
          height 28px
          font-size 14px
          color primary-color
          padding 4px 8px
          border 1px solid primary-color
          line-height 28px
          border-radius 4px
          width 88px
          text-align center
          cursor pointer
        .signing
          border 1px solid gray05
          color gray05
        .repay-detail
          color link-color
          font-size 14px
          line-height 25px
          display flex
          cursor pointer
        .loan-status
          font-size 14px
          font-style normal
          line-height 40px
</style>
